function initBrandDirectory(root) {
  (root || document).querySelectorAll('[data-brand-search]').forEach(function (input) {
    if (input.dataset.brandDirectoryInit) return;
    input.dataset.brandDirectoryInit = 'true';

    const container = input.closest('.brand-directory');
    if (!container) return;

    const jumpnav = container.querySelector('[data-brand-jumpnav]');
    const noResults = container.querySelector('[data-brand-no-results]');
    const groups = Array.from(container.querySelectorAll('[data-brand-group]'));
    const clearButton = container.querySelector('[data-brand-clear]');
    const letterButtons = Array.from(container.querySelectorAll('[data-brand-letter]'));
    const jumpnavButtons = clearButton ? [clearButton].concat(letterButtons) : letterButtons;

    function setPressed(activeButton) {
      jumpnavButtons.forEach(function (button) {
        button.setAttribute('aria-pressed', button === activeButton ? 'true' : 'false');
      });
    }

    function showAllGroups() {
      groups.forEach(function (group) {
        group.hidden = false;
        group.querySelectorAll('[data-brand-item]').forEach(function (item) {
          item.hidden = false;
        });
      });
      if (noResults) noResults.hidden = true;
    }

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        input.value = '';
        showAllGroups();
        setPressed(clearButton);
      });
    }

    letterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = '';
        const letter = button.dataset.brandLetter;
        groups.forEach(function (group) {
          group.hidden = group.dataset.brandLetterGroup !== letter;
        });
        if (noResults) noResults.hidden = true;
        setPressed(button);
      });
    });

    input.addEventListener('input', function () {
      const term = input.value.trim().toLowerCase();
      const searching = term !== '';
      let anyVisible = false;

      groups.forEach(function (group) {
        let groupHasMatch = false;
        group.querySelectorAll('[data-brand-item]').forEach(function (item) {
          const match = !searching || item.dataset.brandName.indexOf(term) !== -1;
          item.hidden = !match;
          if (match) groupHasMatch = true;
        });
        group.hidden = searching && !groupHasMatch;
        if (groupHasMatch) anyVisible = true;
      });

      if (jumpnav) jumpnav.hidden = searching;
      if (noResults) noResults.hidden = !searching || anyVisible;
      if (!searching && clearButton) setPressed(clearButton);
    });
  });
}

document.addEventListener('DOMContentLoaded', function () { initBrandDirectory(); });
document.addEventListener('shopify:section:load', function (event) { initBrandDirectory(event.target); });
